import { QueryOptions } from '@tanstack/react-query'

import { useApi } from '@fortem-monorepo/react-spa'
import { MonthlyRoll } from '@fortem-monorepo/web-sdk'

type Api = ReturnType<typeof useApi>

export const getMonthlyRollOptions = (api: Api, params: MonthlyRoll.GetMonthlyRollParams) => {
  return {
    queryKey: ['monthly-roll', params],
    queryFn: () => api.monthlyRoll.getMonthlyRoll(params),
  } satisfies QueryOptions
}
